import { __awaiter } from "tslib";
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for the Release Notes API.
 *
 * Endpoints:
 * - `getReleaseNotes` – GET `/{releaseNotesPath}` → list of release note descriptors
 * - `downloadReleaseNoteAsText` – GET `/{releaseNotesPath}/download?name={fileName}` → markdown text
 * - `downloadReleaseNoteAsBlob` – GET `/{releaseNotesPath}/download?name={fileName}` → blob URL
 *
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const releaseNotesApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries
        // -----------------------------------------------------------------------
        getReleaseNotes: builder.query({
            query: () => ({
                url: '/release-notes/storage',
                method: 'GET',
            }),
            transformResponse: (response) => response.map((item) => ({
                releaseName: item.releaseName,
                releaseDate: item.releaseDate,
                fileName: item.fileName,
            })),
            providesTags: [CC_API_TAGS.ReleaseNotes],
        }),
        downloadReleaseNoteAsText: builder.query({
            query: ({ fileName }) => ({
                url: `/release-notes/storage/download?name=${encodeURIComponent(fileName)}`,
                method: 'GET',
                responseHandler: 'text',
            }),
        }),
        downloadReleaseNoteAsBlob: builder.query({
            query: ({ fileName }) => ({
                url: `/release-notes/storage/download?name=${encodeURIComponent(fileName)}`,
                method: 'GET',
                responseHandler: (response) => __awaiter(void 0, void 0, void 0, function* () {
                    const blob = yield response.blob();
                    return URL.createObjectURL(blob);
                }),
            }),
        }),
    }),
});
export const { useGetReleaseNotesQuery, useLazyGetReleaseNotesQuery, useDownloadReleaseNoteAsTextQuery, useLazyDownloadReleaseNoteAsTextQuery, useDownloadReleaseNoteAsBlobQuery, useLazyDownloadReleaseNoteAsBlobQuery, } = releaseNotesApi;
